import ConfirmAppointmentView from "./ConfirmAppointmentView";
export default ConfirmAppointmentView;
